export interface ITreeItem {
    /**
     * ID for tree item
     */
    id: number;
    /**
     * Name of the field
     */
    name: string;
    /**
     * The uniqe identifier string of the field
     */
    identifier: string;
    /**
     * item is selected in tree
     */
    isSelectedinTree: boolean;
    /**
     * Defines if the field is mandatory
     */
    required: boolean;

    children?: ITreeItem[];
}

export class TreeItem implements ITreeItem {
    public id: number;
    public name: string;
    public identifier: string;
    public isSelectedinTree: boolean;
    public required: boolean;

    public children?: ITreeItem[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITreeItem);
    constructor(obj?: any) {
        this.id = (obj && obj.id) || 0;
        this.name = (obj && obj.name) || '';
        this.identifier = (obj && obj.identifier) || '';
        this.isSelectedinTree = (obj && obj.isSelectedinTree) || false;
        this.required = (obj && obj.required) || false;

        if (obj && obj.children) {
            this.children = [];

            obj.children.forEach((child: TreeItem) => {
                this.children!.push(new TreeItem(child));
            });
        }
    }
}
